<style lang="scss">
@import '../css/sub.scss';
</style>
<template>
  <div class="donga-audit">
    <audit-header></audit-header>
    <div class="audit-template sub-template">
      <div role="sub" class="audit-sub">
        <div id="sub-sections">
          <div class="visual-top report-complete">
            <h2 class="page-tit">제보확인</h2>
            <p class="page-sub-tit pc-show">감사실과 제보자간의 쌍방향 소통방식으로 운영되며 동아쏘시오 그룹사 임직원 뿐만 아니라<br>고객, 협력회사 등 모든 이해관계자 여러분의 소중한 의견을 자유롭게 제안할 수 있는 곳으로 그룹사와 이해관계자<br>모두의 발전에 도움이 되도록 적극적인 참여 바랍니다.</p>
          </div>
          <div class="col-container pc-container">
            <div class="sub-contents">
                <section class="sub-section">
                    <div class="sub-column inquiry-page-column">
                      <h3 class="section-tit">제보 대상</h3>
                      <ul class="confirm-list">
                        <li class="list-item">
                          <span class="tit">제보대상회사</span>
                          <span class="desc">{{ myPostValues.companyType }}</span>
                        </li>
                        <li class="list-item">
                          <span class="tit">유형</span>
                          <span class="desc">{{ myPostValues.reportType }}</span>
                        </li>
                        <!-- <li class="list-item">
                          <span class="tit">제보확인방법</span>
                          <span class="desc">홈페이지 확인</span>
                        </li> -->
                        <li class="list-item">
                          <span class="tit">익명실명여부</span>
                          <span class="desc">{{ myPostValues.postType }}</span>
                        </li>
                      </ul>
                    </div>
                    <div class="sub-column inquiry-page-column page-column">
                      <h3 class="section-tit">제보 내용</h3>
                      <ul class="confirm-list confirm-desc-list">
                        <li class="list-item item-0"><span class="tit">제목</span> <span class="desc">{{ myPostValues.title }}</span></li>
                        <li class="list-item item-1"><span class="tit">제보일</span> <span class="desc">{{ myPostValues.createdDate }}</span></li>
                        <li class="list-item item-2"><span class="tit">제보내용</span> <span class="desc" v-html="myPostValues.content"></span></li>
                        <li class="list-item item-1"><span class="tit">첨부파일</span> <span class="desc">
                          <button type="button" @click="downFile(fileId, fileName)" style="color:blue;text-decoration:underline">{{fileName}}</button></span></li>
                        <li class="list-item item-3"><span class="tit">처리현황</span> <span class="state">{{ myPostValues.statusTitle }}</span> <p class="inquiry-notice"><i class="icon"></i>본 제보 내역은 해당제보가 완료된 시점부터 1개월 까지만 확인이 가능하고 이후에는 삭제될 예정입니다.</p></li>
                        </ul>
                    </div>
                    <div class="sub-column inquiry-page-column page-column">
                      <h3 class="section-tit">코멘트</h3>
                      <!-- 댓글 영역 -->
                      <comments-list></comments-list>
                      <comments-input></comments-input>
                      <!-- 댓글 영역 -->
                    </div>
                </section>
            </div>
          </div>
        </div>
      </div>
    </div>
    <audit-footer></audit-footer>
  </div>
</template>
<script>
import AuditHeader from '@/components/AuditHeader'
import AuditFooter from '@/components/AuditFooter'
import CommentsList from '@/components/CommentsList'
import CommentsInput from '@/components/CommentsInput'
import { mapGetters, mapActions } from 'vuex'
export default {
  created () {
    this.setInit()
  },
  name: 'InquiryPage',
  components: {
    'audit-header': AuditHeader,
    'audit-footer': AuditFooter,
    'comments-list': CommentsList,
    'comments-input': CommentsInput
  },
  methods: {
    ...mapActions({
      setInit: 'apiInformantInform'
    }),
    downFile (id, filename) {
      this.$store.dispatch('apiInformantAttachfile', {'id': id, 'filename': filename})
    }
  },
  computed: {
    ...mapGetters({
      myPostValues: 'getMyPostValues',
      fileId: 'getPostFileIdUser',
      fileName: 'getPostFilename'
    })
  }
}

</script>



// WEBPACK FOOTER //
// src/pages/InquiryPage.vue